<script>
	import Dispatch from '../../Dispatcher'
	import { faLockAlt, faWallet, faHandHoldingUsd, faPlay, faStop } from '@fortawesome/pro-solid-svg-icons'
	import { faSmile } from '@fortawesome/pro-regular-svg-icons'
	import Fa from 'svelte-fa'
  import { map, tap } from 'rxjs/operators';
  import { withLatestFrom } from 'rxjs/operators';
  import _ from 'lodash'

	let mouseStart = 0

  const scale = Dispatch.getState('view.scale')

  export let command
  export let height

</script>

<div 
  class={'bg-white br1 ' + (command.keyBind ? ' bg-orange ' : ' ')}
  draggable=true 
  style={'height: '+ height + 'px; width: 5px; cursor: w-resize'}
  on:click={e => {e.preventDefault(); e.stopPropagation()}}
  on:dragstart={e => {
    mouseStart = e.offsetX
  }} 
  on:dragend={e => {
    Dispatch.nextAction('width.'+ command.id, -1 * e.offsetX)
    Dispatch.nextAction('position.' + command.id, e.offsetX)
  }}
/>

<style>
</style>